import { CreditNote, InvoiceWithholding } from "@letsbit/malcolmlb";
import { INVOICE_LOCAL_PAGE_TYPE } from "../InvoiceLocal/types";
import { InvoicePageA4 } from "../InvoicePageA4";
import { InvoiceForeignProps } from "./types";
import { useFormatter } from "hooks/utils/useFormatter";
import { useIntl } from "react-intl";
import { useCurrency } from "hooks/user/useCurrencies";
import { messages } from "./messages";
import dayjs from "dayjs";

const InvoicePage: React.FC<
  | { type: INVOICE_LOCAL_PAGE_TYPE.INVOICE; invoice: InvoiceWithholding }
  | { type: INVOICE_LOCAL_PAGE_TYPE.CREDIT_NOTE; invoice: CreditNote }
> = ({ type, invoice }) => {
  const { formatValue } = useFormatter();
  const { formatMessage } = useIntl();
  const currency = useCurrency(invoice.currency);
  return (
    <InvoicePageA4>
      {/* HEADER */}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <h1 style={{ fontSize: 20, fontWeight: 700 }}>
          {invoice.sales_point.legal_name}
        </h1>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            width: "50%",
          }}
        >
          <p style={{ fontSize: 50, fontWeight: 700, width: 220 }}>
            {formatMessage(messages[type])}
          </p>
          <p style={{ fontSize: 20 }}>#{invoice.id}</p>
        </div>
      </div>
      {/* CLIENT DATA */}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "50%",
          }}
        >
          <p style={{ fontSize: 20 }}>Invoice to:</p>
          <p style={{ fontSize: 28, fontWeight: 700 }}>
            {invoice.member.legal_name}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            flexDirection: "column",
            alignItems: "end",
          }}
        >
          <table style={{ textAlign: "right" }}>
            {/* TABLE HEADER */}
            <tr>
              <td
                style={{
                  padding: "10px",
                }}
              >
                Date:
              </td>
              <td
                style={{
                  padding: "10px",
                }}
              >
                {dayjs(invoice.date).format("MMM DD, YYYY")}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  padding: "10px",
                }}
              >
                Date:
              </td>
              <td
                style={{
                  padding: "10px",
                }}
              >
                {dayjs(invoice.due_date).format("MMM DD, YYYY")}
              </td>
            </tr>
            <tr style={{ backgroundColor: "#eaeaea" }}>
              <td
                style={{
                  padding: "10px",
                  fontWeight: 700,
                }}
              >
                Pending payment:
              </td>
              <td
                style={{
                  padding: "10px",
                  fontWeight: 700,
                }}
              >
                0,0
              </td>
            </tr>
          </table>
        </div>
      </div>

      {/* TABLE */}
      <div style={{ width: "100%", height: 200 }}>
        <table style={{ width: "100%", fontSize: 12, textAlign: "center" }}>
          {/* TABLE HEADER */}
          <tr
            style={{
              backgroundColor: "#424242",
              color: "#ffffff",
            }}
          >
            <td
              style={{
                padding: "10px",
                textAlign: "left",
              }}
            >
              Services
            </td>
            <td
              style={{
                padding: "10px",
                width: 150,
              }}
            >
              Amount
            </td>
            <td
              style={{
                padding: "10px",
                width: 250,
              }}
            >
              Price
            </td>
            <td
              style={{
                padding: "10px",
              }}
            >
              Total
            </td>
          </tr>
          {/* TABLE CONTENT */}
          <tr style={{ textAlign: "center" }}>
            <td
              style={{
                padding: "10px",
                textAlign: "left",
                fontWeight: 600,
              }}
            >
              {invoice.description}
            </td>
            <td
              style={{
                padding: "10px",
              }}
            >
              1
            </td>
            <td
              style={{
                padding: "10px",
              }}
            >
              {currency?.ticker_id.toUpperCase() ||
                invoice.currency.toUpperCase()}{" "}
              {formatValue(
                (+invoice.net_amount).toString(),
                currency?.precision,
              )}
            </td>
            <td
              style={{
                padding: "10px",
              }}
            >
              {currency?.ticker_id.toUpperCase() ||
                invoice.currency.toUpperCase()}{" "}
              {formatValue(
                (+invoice.net_amount).toString(),
                currency?.precision,
              )}
            </td>
          </tr>
        </table>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "end",
          justifyContent: "end",
        }}
      >
        <table style={{ width: "40%", textAlign: "right" }}>
          {/* TABLE HEADER */}
          <tr>
            <td
              style={{
                padding: "10px",
                color: "#696969",
              }}
            >
              Subtotal:
            </td>
            <td
              style={{
                padding: "10px",
              }}
            >
              {currency?.ticker_id.toUpperCase() ||
                invoice.currency.toUpperCase()}{" "}
              {formatValue(
                (+invoice.net_amount).toString(),
                currency?.precision,
              )}
            </td>
          </tr>
          {type === INVOICE_LOCAL_PAGE_TYPE.INVOICE
            ? invoice.invoice_taxes.map((tax) => (
                <tr>
                  <td
                    style={{
                      padding: "10px",
                      fontWeight: 700,
                    }}
                  >
                    Importe {tax.general_tax.description}:
                  </td>
                  <td
                    style={{
                      padding: "10px",
                    }}
                  >
                    {currency?.ticker_id.toUpperCase() ||
                      invoice.currency.toUpperCase()}{" "}
                    {formatValue(tax.amount.toString(), currency?.precision)}
                  </td>
                </tr>
              ))
            : invoice.credit_note_taxes.map((tax) => (
                <tr>
                  <td
                    style={{
                      padding: "10px",
                      fontWeight: 700,
                    }}
                  >
                    {tax.general_tax.description}:
                  </td>
                  <td
                    style={{
                      padding: "10px",
                    }}
                  >
                    {currency?.ticker_id.toUpperCase() ||
                      invoice.currency.toUpperCase()}{" "}
                    {formatValue(tax.amount.toString(), currency?.precision)}
                  </td>
                </tr>
              ))}
          <tr>
            <td
              style={{
                padding: "10px",
                color: "#696969",
              }}
            >
              Total:
            </td>
            <td
              style={{
                padding: "10px",
              }}
            >
              {currency?.ticker_id.toUpperCase() ||
                invoice.currency.toUpperCase()}{" "}
              {formatValue(
                (+invoice.net_amount + +invoice.tax_amount).toString(),
                currency?.precision,
              )}
            </td>
          </tr>
        </table>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <p style={{ fontSize: 18, color: "#696969" }}>Terms:</p>
        <p style={{ fontSize: 18 }}>To be paid on monthly hour settlement.</p>
      </div>
    </InvoicePageA4>
  );
};
export const InvoiceForeign: React.FC<InvoiceForeignProps> = ({ invoice }) => {
  return (
    <InvoicePage type={INVOICE_LOCAL_PAGE_TYPE.INVOICE} invoice={invoice} />
  );
};
